import { MapPointRelaisService } from 'Modules/Services/mapPointRelaisService'
import { GeocodeService } from 'Modules/Services/geocodeService'

export default Vue.component('map-pointrelais', {
    template: '#map-pointrelais-template',
    props: ['Relais', 'Open', 'Recherche'],
    data() {
        return {
            MapService: new MapPointRelaisService('map-leaflet'),
            SelectedPointRelais: null,
            CanRechercherDansLaZone: false,
            RebuildMarkers: false,
            SearchAddress: '',
            Addresses: [],
            CurrentTab: 'Carte',
            ShowHoraires: false,
            IsGeolocDisabled: false,
            geocodeService: null
        }
    },
    mounted() {
        this.geocodeService = new GeocodeService(
            $('#map-pointrelais-template').data('countryCodes')
        )

        document.addEventListener('mpr-selection', (e) =>
            this.HandleSelectionEvent(e)
        )
        document.addEventListener(
            'mpr-move',
            () => (this.CanRechercherDansLaZone = true)
        )
        document.addEventListener('mpr-geolocation', () =>
            this.HandleGeolocation()
        )
        $('#modal-map-pointrelais').on('hidden.bs.modal', () =>
            this.ClearData()
        )
    },
    computed: {
        SearchAddressPlaceholder() {
            return $t('RECHERCHE_ADRESSE_PLACEHOLDER')
        }
    },
    methods: {
        HandleGeolocation() {
            if (!navigator.geolocation) {
                return
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.IsGeolocDisabled = false
                    this.LocaliserPointRelais(
                        position.coords.longitude,
                        position.coords.latitude
                    )
                },
                () => {
                    this.IsGeolocDisabled = true
                    this.MapService.HandleGeolocationDisabled()
                }
            )
        },
        ClearData() {
            this.SearchAddress = ''
            this.Addresses = []
            this.CurrentTab = 'Carte'
            this.MapService.ClearMarkers()
        },
        OpenModal() {
            $('#modal-map-pointrelais').modal('show')
        },
        GetSelectedPointRelais() {
            if (this.Relais.some((x) => x.IsSelected)) {
                return this.Relais.find((x) => x.IsSelected)
            }

            this.Relais[0].IsSelected = true

            return this.Relais[0]
        },
        SetSelectedPointRelais(pointRelais) {
            this.SelectedPointRelais = pointRelais
            this.MapService.CenterPointRelais(pointRelais)
        },
        HandleSelectionEvent(e) {
            if (!e.detail.Identifiant) {
                return
            }

            const selectedPointRelais = this.Relais.find(
                (x) => x.Identifiant === e.detail.Identifiant
            )

            this.SelectedPointRelais = selectedPointRelais

            this.ScrollToSelectedPointRelais()

            this.MapService.CenterPointRelais(selectedPointRelais)
        },
        ChoisirPointRelais(pointRelais) {
            const payload = pointRelais ?? this.SelectedPointRelais

            this.$emit('choisirpointrelais', payload)

            $('#modal-map-pointrelais').modal('hide')

            this.MapService.ClearMarkers()
        },
        RechercherDansLaZone() {
            this.CanRechercherDansLaZone = false

            const { Latitude, Longitude } =
                this.MapService.GetMapCenterCoordinates()

            this.LocaliserPointRelais(Longitude, Latitude)
        },
        GetPointRelaisSmallIconUrl(pointRelais) {
            switch (pointRelais.MoyenLivraison) {
                case 9:
                    return 'https://media.modz.fr/pictures/site/images/element_graphique/map/small-icon-relaiscolis.svg'
                case 8:
                case 14:
                    return 'https://media.modz.fr/pictures/site/images/element_graphique/map/small-icon-chronopost.svg'
                default:
                    return ''
            }
        },
        ScrollToSelectedPointRelais() {
            this.$nextTick(() => {
                this.$refs[
                    this.SelectedPointRelais.Identifiant
                ][0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center'
                })
            })
        },
        GetPointRelaisTypeLabel(Relai) {
            return Relai.MoyenLivraison === 9
                ? 'Relais Colis'
                : 'Chronopost Pickup'
        },
        GetJourHoraire(jour) {
            switch (jour) {
                case '1':
                    return $t('LUNDI')
                case '2':
                    return $t('MARDI')
                case '3':
                    return $t('MERCREDI')
                case '4':
                    return $t('JEUDI')
                case '5':
                    return $t('VENDREDI')
                case '6':
                    return $t('SAMEDI')
                case '7':
                    return $t('DIMANCHE')
                default:
                    return ''
            }
        },
        GetHoraires(horaires) {
            if (!horaires) {
                return $t('FERME')
            }

            return horaires
                .split(' / ')
                .map((x) => (['', '-'].includes(x.trim()) ? $t('FERME') : x))
                .join(' / ')
                .replace(' - ', '-')
        },
        LocaliserRelaisAdresse() {
            this.$emit('localiserrelaisadresse')
        },
        async SelectAddress(magicKey) {
            if (!magicKey) {
                return
            }

            this.ClearData()

            const result = await this.geocodeService.RechercheKey(magicKey)

            if (!result.candidates) {
                return
            }

            this.LocaliserPointRelais(
                result.candidates[0].location.x,
                result.candidates[0].location.y
            )

            this.Recherche.Longitude = result.candidates[0].location.x
            this.Recherche.Latitude = result.candidates[0].location.y

            this.RebuildMarkers = true

            this.$emit('localiserrelaisgeo')
        },
        LocaliserPointRelais(Longitude, Latitude) {
            this.Recherche.Longitude = Longitude
            this.Recherche.Latitude = Latitude

            this.RebuildMarkers = true

            this.$emit('localiserrelaisgeo')
        },
        SetCurrentTab(currentTab) {
            this.Addresses = []
            this.CurrentTab = currentTab
        }
    },
    watch: {
        Open() {
            if (!this.Relais.length) {
                return
            }

            this.CanRechercherDansLaZone = false

            this.SelectedPointRelais = this.GetSelectedPointRelais()

            this.MapService.InitMap(this.Relais)

            this.OpenModal()

            this.MapService.CenterPointRelais(this.SelectedPointRelais)

            this.ScrollToSelectedPointRelais()
        },
        Relais() {
            if (!this.RebuildMarkers || !this.Relais.length) {
                return
            }

            this.CanRechercherDansLaZone = false

            this.SelectedPointRelais = this.GetSelectedPointRelais()

            this.MapService.ClearMarkers()

            this.MapService.BuildMarkers(this.Relais)

            this.RebuildMarkers = false

            this.MapService.CenterPointRelais(this.SelectedPointRelais)

            this.ScrollToSelectedPointRelais()
        },
        async SearchAddress() {
            if (!this.SearchAddress) {
                this.Addresses = []
                return
            }

            if (this.SearchAddress.length < 3) {
                return
            }

            const result = await this.geocodeService.RechercheAdresse(
                this.SearchAddress
            )

            if (result && result.suggestions) {
                this.Addresses = result.suggestions
            }
        }
    }
})
